import Checkbox from "@mui/material/Checkbox";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import TextField from "@mui/material/TextField";

import { STATUS_FILTER_OPTIONS } from "../../utils/constants";

const WorkListStatusFilter = ({ handleChange }) => {
  return (
    <Autocomplete
      multiple
      autoComplete={true}
      options={STATUS_FILTER_OPTIONS}
      disableCloseOnSelect
      onChange={handleChange}
      getOptionLabel={(option) => option}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
            checkedIcon={<CheckBoxIcon fontSize="small" />}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option}
        </li>
      )}
      style={{ width: "auto", marginBottom: 15 }}
      renderInput={(params) => (
        <TextField {...params} label="Filter by Status" placeholder="Status" />
      )}
    />
  );
};

export default WorkListStatusFilter;
